var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H21.75C21.75 5.58579 21.4142 5.25 21 5.25V6ZM21 18V18.75C21.4142 18.75 21.75 18.4142 21.75 18H21ZM8 18L7.46967 18.5303C7.61032 18.671 7.80109 18.75 8 18.75V18ZM2 12L1.46967 11.4697C1.17678 11.7626 1.17678 12.2374 1.46967 12.5303L2 12ZM8 6V5.25C7.80109 5.25 7.61032 5.32902 7.46967 5.46967L8 6ZM20.25 6V18H21.75V6H20.25ZM21 17.25H8V18.75H21V17.25ZM8.53033 17.4697L2.53033 11.4697L1.46967 12.5303L7.46967 18.5303L8.53033 17.4697ZM2.53033 12.5303L8.53033 6.53033L7.46967 5.46967L1.46967 11.4697L2.53033 12.5303ZM8 6.75H21V5.25H8V6.75ZM11.25 12C11.25 12.6904 10.6904 13.25 10 13.25V14.75C11.5188 14.75 12.75 13.5188 12.75 12H11.25ZM10 13.25C9.30964 13.25 8.75 12.6904 8.75 12H7.25C7.25 13.5188 8.48122 14.75 10 14.75V13.25ZM8.75 12C8.75 11.3096 9.30964 10.75 10 10.75V9.25C8.48122 9.25 7.25 10.4812 7.25 12H8.75ZM10 10.75C10.6904 10.75 11.25 11.3096 11.25 12H12.75C12.75 10.4812 11.5188 9.25 10 9.25V10.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.4cf738c78cf17d4f0c12911a2e51cf5e.svg";
export { ForwardRef as ReactComponent };